import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

import { useStores } from "@stores/hooks/useStores.ts";
import {
  DataFetcher,
  DataFetcherProps
} from "@ui-components/data-fetcher/DataFetcher.tsx";

import { BookingCalendarEventContext } from "../BookingCalendarEventContext.tsx";

export const BookingEventCalloutDataFetcher: React.FC<
  Pick<DataFetcherProps<void>, "children">
> = observer(({ children }) => {
  const { billing } = useStores();

  const { calendarEvent, getStates, loadPatientNotices, loadInvoiceItems } =
    useContext(BookingCalendarEventContext);

  const fetch = async () => {
    await Promise.all([
      ...calendarEvent.invoiceIds.map(invoiceId =>
        billing.getInvoice(invoiceId)
      ),
      getStates(),
      loadPatientNotices(),
      calendarEvent.loadEpisodeOfCare(),
      loadInvoiceItems()
    ]);
  };

  return (
    <DataFetcher
      noExceptionsHandlers
      refetchId={calendarEvent.id}
      fetch={fetch}
    >
      {children}
    </DataFetcher>
  );
});
